import axios from 'axios';
import { Download, FileText, FolderTree, Shield } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function DocumentsTab({ token, folders, documents }) {
  const downloadDocument = async (documentId) => {
    try {
      const response = await axios.get(`${API_URL}/api/portal/documents/${documentId}/download`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const blobUrl = URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
      window.open(blobUrl, '_blank');
      setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to download document');
    }
  };

  if (!documents?.length) {
    return <div className="bg-white rounded-xl border border-gray-200 p-12 text-center"><FileText className="w-12 h-12 text-gray-300 mx-auto mb-4" /><p className="text-gray-500">No client documents yet</p></div>;
  }

  return (
    <div className="space-y-4" data-testid="portal-documents-tab">
      {folders.map((folder) => {
        const folderDocs = documents.filter((document) => document.folder_id === folder.id);
        if (folderDocs.length === 0) return null;
        return (
          <div key={folder.id} className="bg-white rounded-xl border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="font-bold text-[#0A1628] flex items-center gap-2"><FolderTree className="w-4 h-4 text-[#014DB7]" /> {folder.name}</h3>
                {folder.locked && <p className="text-xs text-amber-600 mt-1 flex items-center gap-1"><Shield className="w-3 h-3" /> Signed contracts are protected</p>}
              </div>
              <span className="text-sm text-gray-500">{folder.document_count || folderDocs.length} file(s)</span>
            </div>
            <div className="space-y-3">
              {folderDocs.map((document) => (
                <div key={document.id} className="flex items-center justify-between gap-3 p-3 bg-gray-50 rounded-xl">
                  <div className="min-w-0">
                    <p className="font-medium text-sm text-[#0A1628] truncate">{document.display_name || document.original_name}</p>
                    <p className="text-xs text-gray-500 mt-1">{document.source_type === 'contract_book' ? `${document.document_count || 0} signed document(s)` : document.content_type || 'Document'}</p>
                  </div>
                  <button onClick={() => downloadDocument(document.id)} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#014DB7] text-white text-sm font-medium rounded-lg hover:bg-[#013a8c] transition-colors" data-testid={`portal-download-document-${document.id}`}>
                    <Download className="w-4 h-4" /> Download
                  </button>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}